import React from 'react';
import ModalsPayment from './ModalsPayment';
import ModalsSepaStripe from './ModalsSepaStripe';
import ModalsAcompteEcheance from './ModalsAcompteEcheance';

export default function Modals(props) {
  return (
    <>
      <ModalsPayment {...props} />
      <ModalsSepaStripe {...props} />
      <ModalsAcompteEcheance {...props} />
    </>
  );
}
